module.exports = __webpack_public_path__ + "images/emoji/sleeping.3246d17622ea590c707b.png";